// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ReadMoreButton = require("../../../components/buttons/ReadMoreButton.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MySharedPostsWidgetList_query_graphql = require("../../../__generated__/MySharedPostsWidgetList_query_graphql.bs.js");
let MySharedPostsListPaginationQuery_graphql = require("../../../__generated__/MySharedPostsListPaginationQuery_graphql.bs.js");
let MySharedPostsWidgetListItemSharedProperty = require("./MySharedPostsWidgetListItemSharedProperty.bs.js");

let getConnectionNodes = MySharedPostsWidgetList_query_graphql.Utils.getConnectionNodes;

let convertFragment = MySharedPostsWidgetList_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MySharedPostsWidgetList_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MySharedPostsWidgetList_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MySharedPostsWidgetList_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MySharedPostsWidgetList_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = MySharedPostsListPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = MySharedPostsListPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MySharedPostsWidgetList_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MySharedPostsWidgetList_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

let QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MySharedPostsWidgetList$MySharedPostsEmpty(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      "You have not shared any properties",
      JsxRuntime.jsx("br", {})
    ]
  });
}

let MySharedPostsEmpty = {
  make: MySharedPostsWidgetList$MySharedPostsEmpty
};

function MySharedPostsWidgetList(props) {
  let match = usePagination(props.query);
  let isLoadingNext = match.isLoadingNext;
  let hasNext = match.hasNext;
  let loadNext = match.loadNext;
  let items = getConnectionNodes(match.data.sharedPostsForCurrentUserV5);
  let tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ReadMoreButton.make, {
            href: "/my_shared_posts",
            children: "View All"
          }),
          className: "mt-4"
        }) : null
    ) : (
      hasNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => {
              loadNext(30, undefined);
            },
            disabled: isLoadingNext,
            className: "w-full",
            children: "See More Shared Posts"
          }),
          className: "mt-4"
        }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      items.length !== 0 ? JsxRuntime.jsx("div", {
          children: items.map(item => {
            if (item.__typename === "SharedPropertyV5") {
              return JsxRuntime.jsx(MySharedPostsWidgetListItemSharedProperty.make, {
                sharedProperty: item.fragmentRefs
              }, item.databaseId);
            } else {
              return null;
            }
          }),
          className: "flex flex-col border-b mb-6"
        }) : JsxRuntime.jsx(MySharedPostsWidgetList$MySharedPostsEmpty, {}),
      tmp,
      isLoadingNext ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loader.make, {
            loadingText: "Loading more shared posts..."
          }),
          className: "mt-4"
        }) : null
    ]
  });
}

let make = MySharedPostsWidgetList;

exports.QueryFragment = QueryFragment;
exports.MySharedPostsEmpty = MySharedPostsEmpty;
exports.make = make;
/* Loader Not a pure module */
